import { render, staticRenderFns } from "./AdhdOntarioBanner.vue?vue&type=template&id=408bd2b3&scoped=true&"
import script from "./AdhdOntarioBanner.vue?vue&type=script&lang=js&"
export * from "./AdhdOntarioBanner.vue?vue&type=script&lang=js&"
import style0 from "./AdhdOntarioBanner.vue?vue&type=style&index=0&id=408bd2b3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408bd2b3",
  null
  
)

export default component.exports